import { formatNumber } from "@/shared/utils";
import { cn } from "@/lib/utils";

interface OptionAwardCardProps {
  /** The partner's option key, e.g. "starter" / "pro" / "scale". */
  optionKey: string;
  /** DON this tier pays, already adjusted for premium. */
  award: string | number;
  /** Rows sit in one container; every row but the first draws a divider. */
  withDivider?: boolean;
}

/**
 * One tier inside the OPTION_TASK sheet — read-only.
 *
 * Which tier the user actually buys is reported by the partner in its check
 * response, so there is nothing to pick here: the list only tells the user
 * what each tier is worth before they leave for the partner's page.
 *
 * The partner names its own tiers, so the key is shown as-is apart from
 * capitalising the first letter — inventing a translation here would drift
 * from what the user reads on the partner's own page.
 */
const OptionAwardCard = ({
  optionKey,
  award,
  withDivider = false,
}: OptionAwardCardProps) => {
  const label = optionKey.charAt(0).toUpperCase() + optionKey.slice(1);

  return (
    <div
      className={cn(
        "flex items-center justify-between gap-3 px-4 py-3.5",
        withDivider && "border-t border-white/08"
      )}
    >
      <span className="text-[15px] font-semibold leading-130 text-white">
        {label}
      </span>
      {/* tabular-nums keeps 300 / 900 / 3000 on one vertical edge. */}
      <span className="text-[15px] font-bold leading-130 text-orange-100 tabular-nums">
        +{formatNumber(award)} DON
      </span>
    </div>
  );
};

export default OptionAwardCard;
